// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"6dc9c2ec","453":"df9e86e7","732":"0a60ad4d","977":"8355b349"}[chunkId] + ".chunk.js");